// TDIC: ErrorPage.messages.js added
import { defineMessages } from 'react-intl';

export default defineMessages({
    unableToAccessPage: {
        id: 'tdic.ErrorPage-error.Unable to access document',
        defaultMessage: 'Apologies: we are unable to access the page that you are looking for.',
    },
    backToHomePage: {
        id: 'tdic.ErrorPage-error.Back to Home Page',
        defaultMessage: 'Back to Home Page'
    }
});
